//jshint esversion:8

import { isBDay } from "./ext/openDate.js";
import setPage from "./ext/setPage.js";
import { late, soon } from "./pages.js";
import { animate } from "./animation.js";
import { startCountdown } from "./ext/countdown.js";

/******************************************************* SETUP ************************************************************/

if (true) {
  const status = isBDay();
  if (status === "IS_EARLY") {
    setPage(soon);
    startCountdown();
  }
  if (status === "IS_LATE") setPage(late);
  if (status === "ON_TIME") animate();
} else {
  animate();
}
